$('.hamburger-icon').on('click', function(e) {
    e.stopPropagation();
    e.preventDefault();

    // If opening menu, scroll body to top
    if ( ! $(this).hasClass('show-close-icon') ) {
      // Scroll to top of page
      $('html, body').animate({ scrollTop: 0 }, '400');
    }
    toggleMobileMenu();
});

// Adjust Mobile Menu Height
function adjustMobileMenuHeight() {

  var headerContainerHeight = $('.header-container').innerHeight(),
      adminBarHeight = ( $('#wpadminbar').length ? $('#wpadminbar').innerHeight() : 0 ),
      globalNotificationHeight = ( $('.global-header-notification').length ? $('.global-header-notification').innerHeight() : 0 ),
      mobileCallBarHeight = ( $('.mobile-header-call-bar').css('display') == 'block' ? $('.mobile-header-call-bar').innerHeight() : 0),
      menuPadding = headerContainerHeight + adminBarHeight + globalNotificationHeight + mobileCallBarHeight + 100; // + 100 for mobile nav bar

  $('.header-main-menu-container .header-main-menu-inner').css({
    'padding-bottom': menuPadding + 'px'
  });
} // adjustMobileMenuHeight()

// Toggle Mobile Menu
function toggleMobileMenu(action) {
  var action = action || null,
      hamburger = $('.hamburger-icon'),
      menu = $('.header-main-menu-container'),
      overlay = $('.mobile-menu-overlay'),
      marginTop = 0;

  if (action == 'close') {
    hamburger.removeClass('show-close-icon');
    menu.removeClass('active');
    menu.find('.header-main-menu-inner').css('padding-bottom', 0);
    $('html, body').removeClass('no-scroll');
    overlay.fadeOut('fast');
    return;
  }

  // Stop click propagation
  menu.on('click', function (e) {
    e.stopPropagation();
  });

  $('html, body').toggleClass('no-scroll');

  menu.toggleClass('active');
  overlay.fadeToggle('fast');

  if ( hamburger.hasClass('show-close-icon') ) {
    menu.find('.header-main-menu-inner').css('padding-bottom', 0);
    hamburger.removeClass('show-close-icon');
    // Make sure menu starts at the top
    setTimeout(function() {
      $('.header-main-menu-inner').animate({ scrollTop: 0 }, '1');
    }, 300);
  } else {
    hamburger.addClass('show-close-icon');
    adjustMobileMenuHeight();
  }
}

// Close menu on window resize or orientation change
$(window).on('resize orientationchange', function() {
  toggleMobileMenu('close');
  $('.header-main-menu > ul > li > a').removeClass('active');
  $('.header-main-menu .sub-menu').removeClass('active');
});

// Navigation sub-menu toggle
$('.header-main-menu > ul > li.menu-item-has-children > a').on('click', function (e) {

  // If mobile menu is NOT active
  if ( ! $('.header-main-menu-container').hasClass('active') ) {
    e.preventDefault();
    // Hide any other sub-menus
    $('.header-main-menu .sub-menu').not( $(this).siblings('.sub-menu') ).removeClass('active');
    // Remove any active classes
    $('.header-main-menu > ul > li > a').not( $(this) ).removeClass('active');
    // Add active class
    $(this).toggleClass('active');
    // Toggle this submenu
    $(this).siblings('.sub-menu').toggleClass('active');
  }
});

// Close .sub-menu on <main> click and remove any active classes
$('main, footer').on('click', function() {
  $('.header-main-menu .sub-menu').removeClass('active');
  $('.header-main-menu > ul > li > a').removeClass('active');
});